module.exports = __webpack_public_path__ + "static/media/image_16.0d2a9dfe.png";